import React from "react";
import Navbar from '../Components/Navbar';
import { isMobile } from "react-device-detect";
import Footer from "../Components/Footer";
import { motion } from "motion/react";
import Core from "../Components/Core";

const Contact = () => {
  return (
    <div>
      <Navbar />

      {/* CONTACT HEADER */}
      <section className="bg-white pb-lg-6 pb-4 px-lg-6 px-0">
        <div className="container">
          <div className="row align-items-center pt-lg-5 pt-6 pb-lg-6 px-lg-0">

            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-12 mb-6"
            >
              <div className="text-center">
                <div className="fs-1 fw-semibold text-dark">
                  Contact Ebun Heritage Schools
                </div>
                <div className="text-muted text-uppercase mb-2 fs-6">
                  We are here to serve you
                </div>
              </div>
            </motion.div>


            {/* GOOGLE MAP - HEAD CAMPUS */}
            <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="col-lg-10 offset-lg-1 mb-6 mt-lg-4 mt-4"
            >
            <div
                className="map-container"
                style={{
                width: "100%",
                height: "400px",
                borderRadius: "12px",
                overflow: "hidden"
                }}
            >
                <iframe
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                allowFullScreen
                src="https://www.google.com/maps?q=101,+Liasu+Road,+Egbe-Idimu,+Lagos&output=embed"
                ></iframe>
            </div>
            </motion.div>


            {/* IMAGE */}
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 order-lg-2 text-center"
            >
              <img
                src="../../assets/images/background/school.png"
                alt="Ebun Heritage School Building"
                width={500}
                className="img-fluid mb-lg-4"
              />
            </motion.div>

            {/* CONTACT DETAILS */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 order-lg-1 mb-6 mt-lg-8 mt-4"
            >
              <div className="fs-t2 text-gray-800 fw-semibold mb-4 text-lg-start text-center">
                We Are Just a Few Minutes Away!
              </div>

              <div className={`fs-4 text-dark ${isMobile ? 'px-4' : 'text-justify'}`}>
                At <span className="fw-semibold">Ebun Heritage Schools</span>, we are committed to
                nurturing excellence and shaping destinies. Whether you have
                questions about admissions, academics, WAEC/NECO preparation,
                or our holistic programs, our team is ready to assist you.
                <br /><br />

                📧 Email: <span className="fw-semibold">admin@ebunheritageschools.com</span> <br />
                📞 Phone: <span className="fw-semibold">+234 809 754 8759, +234 802 331 3735, +234 803 372 8705</span> <br /><br />

                📍 <span className="fw-semibold">Head Campus Address:</span> <br />
                101, Liasu Road, <br />
                Egbe-Idimu, Lagos State, Nigeria.
                <br />

                📍 <span className="fw-semibold">Tolu-Aluko Campus Address:</span> <br />
                18, Imaam Saliu Str., <br />
                Off Afolabi B/Stop, Akesan Lagos State, Nigeria.
                <br />

                📍 <span className="fw-semibold">Akesan Campus Address:</span> <br />
                22, Tolu Aluko Str., <br />
                Off Liasu Rd, Council-Idimu, Lagos State, Nigeria.
                <br /><br />

                We look forward to welcoming you into the Ebun Heritage family.
                Contact us today and experience academic excellence built on
                strong moral and spiritual foundations.
            </div>
            </motion.div>

          </div>
        </div>
      </section>

      {/* CONTACT CARD */}
      <section className="bg-back pt-lg-6 pt-8 pb-lg-6 pb-4 px-lg-6 px-0">
        <div className="container">

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="px-lg-18 mt-lg-n14 mt-n8"
          >
            <div
              className="card shadow-lg bg-dark-blue p-4 p-lg-6"
              style={{ borderRadius: '30px' }}
            >
              <div className="d-lg-flex text-center justify-content-center align-items-center">

                <div>
                  <div className="fs-5 text-white">Email Us:</div>
                  <div className="fs-3 text-white">
                    admin@ebunheritageschools.com
                  </div>
                </div>

                <div className="mx-4">
                  <button className="btn btn-icon btn-white shadow-lg fw-semibold py-4 px-4 fs-5 rounded-circle">
                    OR
                  </button>
                </div>

                <div>
                  <div className="fs-5 text-white">Call Us:</div>
                  <div className="fs-3 text-white">
                    +234 809 754 8759
                  </div>
                </div>

              </div>
            </div>
          </motion.div>

          {/* OUR GOAL SECTION */}
          <div className="row align-items-center pt-lg-10 pt-6 pb-lg-6 px-lg-0">

            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 mb-6"
            >
              <div className="fs-t2 fw-semibold mb-4 text-lg-start text-center">
                Our Goal
              </div>

              <div className={`fs-5 text-dark ${isMobile ? 'px-4' : 'text-justify'}`}>
                At Ebun Heritage Schools, our goal is to mould lives and
                destinies through academic excellence, discipline, and
                strong moral values. We harness the God-given potential in
                every child, guiding them to discover purpose, develop
                confidence, and build a dream for a glorious future.
                <br /><br />
                Through innovative teaching, mentorship, and a supportive
                learning environment, we prepare students to excel in
                internal and external examinations such as WAEC and NECO,
                while growing into responsible and globally minded leaders.
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="col-lg-6 text-center"
            >
              <img
                src="../../assets/images/background/value.png"
                alt="Ebun Heritage Core Values"
                width={500}
                className="img-fluid mb-lg-4"
              />
            </motion.div>

          </div>
        </div>
      </section>

      <Core />
      <Footer />
    </div>
  )
}

export default Contact;
